export default __webpack_public_path__ + "static/media/post3.0225e06e.jpg";